import React, { useEffect, useState } from "react";

const Approval = (props) => {
  const [items, setItems] = useState([]);

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <h1 className="font-bold mb-5">Hello from Approval page</h1>
    </div>
  );
};

Approval.auth = { path: "/approval", role: "super-admin" };
export default Approval;
